customElements.whenDefined("x-drawer").then(() => {
  const Drawer = customElements.get("x-drawer");

  class DrawerV1 extends Drawer {

    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();
      this.addEventListener('dialog:after-hide', () => {
        this.querySelectorAll('video').forEach(v => v.pause());
      });
    }

    _getClipPathProperties() {
      if (this.openFrom === "bottom") {
        return [
          "inset(100% 0 0 0 round var(--rounded-lg) var(--rounded-lg) 0 0)",
          "inset(0 0 0 0 round var(--rounded-lg) var(--rounded-lg) 0 0)",
        ];
      }
      return super._getClipPathProperties();
    }

  }

  customElements.define("drawer-v1", DrawerV1);
});


